// ── SCROLL NAV ──
const nav = document.getElementById('nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 50);
  });
}

// ── SCROLL REVEAL ──
const reveals = document.querySelectorAll('.reveal');
if (reveals.length) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        setTimeout(() => entry.target.classList.add('visible'), i * 80);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  reveals.forEach(el => observer.observe(el));
}

// ── CART DRAWER ──
class MeiyaCart {
  constructor() {
    this.drawer  = document.getElementById('cart-drawer');
    this.overlay = document.getElementById('cart-overlay');
    this.toggle  = document.getElementById('cart-toggle');
    this.countEl = document.getElementById('cart-count');
    this.body    = document.getElementById('cart-drawer-body');
    this.footer  = document.getElementById('cart-footer');
    this.subtotalEl = document.getElementById('cart-subtotal');

    if (!this.drawer) return;
    this.drawer.inert=true;
    this.drawer.setAttribute('aria-hidden','true');

    this.toggle?.addEventListener('click', () => this.open());
    this.overlay?.addEventListener('click', () => this.close());
    document.getElementById('cart-close')?.addEventListener('click', () => this.close());

    document.addEventListener('keydown', (e) => {
      if (!this.drawer.classList.contains('open')) return;
      if (e.key === 'Escape') this.close();
      if (e.key === 'Tab') {
        const targets=[...this.drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')].filter(el=>el.getClientRects().length);
        const first=targets[0],last=targets[targets.length-1];
        if(e.shiftKey&&document.activeElement===first){e.preventDefault();last?.focus();}
        else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus();}
      }
    });

    this.fetchAndRender();
  }

  async fetchAndRender() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      this.renderItems(cart);
      this.updateBadge(cart.item_count);
    } catch (_) {}
  }

  updateBadge(count) {
    if (!this.countEl) return;
    this.countEl.textContent = count;
    this.countEl.style.display = count > 0 ? 'flex' : 'none';
    // Update nav checkout button behaviour based on cart state
    const checkoutBtn = document.getElementById('nav-checkout');
    if (checkoutBtn) {
      if (count === 0) {
        checkoutBtn.dataset.empty = 'true';
      } else {
        delete checkoutBtn.dataset.empty;
      }
    }
  }

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  renderItems(cart) {
    if (!this.body) return;

    if (cart.items.length === 0) {
      this.body.innerHTML = `
        <div class="cart-empty">
          <p>Your cart is empty.</p>
          <a href="/collections/all" class="cart-continue">Continue Shopping →</a>
        </div>`;
      if (this.footer) this.footer.style.display = 'none';
      return;
    }

    this.body.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item-image">
          ${item.image ? `<img src="${item.image}" alt="${this.escape(item.product_title)}" loading="lazy">` : ''}
        </div>
        <div class="cart-item-details">
          <p class="cart-item-title">${this.escape(item.product_title)}</p>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="cart-item-variant">${this.escape(item.variant_title)}</p>` : ''}
          <div class="cart-item-qty">
            <button class="qty-btn" data-action="decrease" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button class="qty-btn" data-action="increase" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <div class="cart-item-price">${this.formatMoney(item.line_price)}</div>
      </div>
    `).join('');

    if (this.subtotalEl) this.subtotalEl.textContent = this.formatMoney(cart.total_price);
    if (this.footer) this.footer.style.display = 'block';

    // Quantity buttons
    this.body.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        const current = parseInt(btn.dataset.qty, 10);
        const qty = btn.dataset.action === 'increase' ? current + 1 : current - 1;
        await this.changeQty(key, qty);
      });
    });
  }

  async changeQty(key, qty) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    this.fetchAndRender();
  }

  escape(str) {
    const d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  open() {
    if (!this.drawer) return;
    this.returnFocus=document.activeElement;
    this.drawer.inert=false;
    this.drawer.setAttribute('aria-hidden','false');
    this.drawer.classList.add('open');
    document.getElementById('cart-close')?.focus();
    this.overlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
    this.fetchAndRender();
  }

  close() {
    if (!this.drawer?.classList.contains('open')) return;
    this.drawer.classList.remove('open');
    this.drawer.setAttribute('aria-hidden','true');
    this.drawer.inert=true;
    this.returnFocus?.focus();
    this.overlay?.classList.remove('open');
    document.body.style.overflow = '';
  }
}

const meiyaCart = new MeiyaCart();

// ── NAV CHECKOUT: if cart empty, open cart drawer instead ──
document.getElementById('nav-checkout')?.addEventListener('click', (e) => {
  if (e.currentTarget.dataset.empty === 'true') {
    e.preventDefault();
    meiyaCart.open();
  }
});

// ── CART FORM (Add to Cart → open drawer) ──
const cartForm = document.querySelector('.product-form form');
if (cartForm) {
  cartForm.addEventListener('submit', async e => {
    e.preventDefault();
    const btn=cartForm.querySelector('.btn-add-to-cart');
    if (!btn || btn.disabled) return;
    const original=btn.textContent;
    let error=cartForm.querySelector('.cart-form-error');
    if (!error) {error=document.createElement('p');error.className='cart-form-error';error.setAttribute('role','alert');cartForm.append(error);}
    error.textContent='';btn.disabled=true;btn.textContent='Adding…';
    try {
      const res=await fetch('/cart/add.js',{method:'POST',body:new FormData(cartForm)});
      if(!res.ok){let data;try{data=await res.json()}catch{}throw new Error(data?.description||'Could not add this candle. Please try again.');}
      await meiyaCart.fetchAndRender();meiyaCart.open();
    } catch(err) {error.textContent=err.message||'Please try again.';}
    finally {btn.disabled=false;btn.textContent=original;}
  });
}

// ── REVIEW PAGE — star rating wires rating value into hidden field ──
const starRating = document.getElementById('star-rating');
const ratingInput = document.getElementById('rating-input');
if (starRating && ratingInput) {
  starRating.querySelectorAll('.star-input').forEach(radio => {
    radio.addEventListener('change', () => {
      ratingInput.value = radio.value;
    });
  });
}

